<template>
  <v-theme-provider dark>
    <section id="about-image-b">
      <base-img
        :height="$vuetify.breakpoint.mdAndUp ? 250 : 225"
        :gradient="gradient"
        :src="require('@/assets/about-img-01.png')"
        flat
        max-width="100%"
      >
        <v-row
          align="center"
          class="ma-0 fill-height text-center"
          justify="center"
        >
          <v-col cols="12">
            <base-heading title="코로나19를 이겨낸 대한민국의 원동력은 디지털 경제!<br>비대면 비접촉 방식의 새로운 건물관리 솔루션" />

            <div class="white--text">
              Post Corona 시대는 이미 시작되었습니다. 기존의 대면 접촉 방식의 서비스는 더 이상 환영받지 못할 수 있습니다.<br>Flag FMS 서비스로 차세대 용역서비스를 시작하세요!
            </div>
          </v-col>
        </v-row>
      </base-img>
    </section>
  </v-theme-provider>
</template>

<script>
  // Components
  import {
    HexToRGBA,
    RGBAtoCSS,
  } from 'vuetify/lib/util/colorUtils'

  export default {
    name: 'AboutImage',

    provide: {
      heading: { align: 'center' },
    },

    computed: {
      gradient () {
        const color = `${this.$vuetify.theme.themes.light.secondary}CC`
        const overlay = RGBAtoCSS(HexToRGBA(color))

        return `to top, ${overlay}, ${overlay}`
      },
    },
  }
</script>

<style lang="sass">
  #hero-alt
    .v-breadcrumbs__item
      color: #FFFFFF
</style>
